import { createReducer, on } from '@ngrx/store';

import {
  clearFlightResultsCabinAction,
  fetchFlightResultsCabinSuccessAction
} from '@flight-results/store/actions/flights-results.actions';
import { FlightAmenitieResultItem } from '@app/entities/flight-results';

export const initialState: FlightAmenitieResultItem[] = null;

export const flightCabinDetailSelectedReducer = createReducer(
  initialState,
  on(clearFlightResultsCabinAction, (state) => {
    return initialState;
  }),
  on(fetchFlightResultsCabinSuccessAction, (state, { itineraryId, amenities }) => {
    const results: FlightAmenitieResultItem[] = state || [];
    const exists = results.find(x => x.itineraryId === itineraryId);
    if (exists) {
      const previousAmenities = exists.amenities.filter(x => !amenities.some(b => b.Index === x.Index));
      return [
        ...results.filter(x => x.itineraryId !== itineraryId),
        { ...exists, amenities: [ ...previousAmenities, ...amenities ] }
      ];
    }
    results.push({ itineraryId, amenities });
    return results;
  })
);
